import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Element from 'element-ui';
import VCharts from 'v-charts';

import Common from '@/plugins/common.js';
import 'element-ui/lib/theme-chalk/index.css';
import '@/io/request.js';

Vue.use(Element);
Vue.use(VCharts);
Vue.use(Common);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
